<template>
  <div class="create">
    <!-- card -->
    <el-card class="box-card">
      <!-- card header -->
      <div slot="header" class="clearfix">
        <span>模板创建</span>
        <el-button
          class="tz-r tz-create-btn"
          type="primary"
          round
          @click="jump('/checkinfo')"
          >返回</el-button
        >
      </div>
      <!-- card header -->

      <!-- card content -->
      <el-form
        :model="formData"
        :rules="rules"
        label-width="130px"
        ref="formData"
      >
        <el-form-item label="序号" prop="sort">
          <el-input v-model="formData.sort"></el-input>
        </el-form-item>

        <el-form-item label="事项类型" prop="itemType">
          <el-select clearable v-model="formData.itemType">
            <el-option
              v-for="item in itemList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="事项名称" prop="itemName">
          <el-input clearable v-model="formData.itemName"> </el-input>
        </el-form-item>
        <el-form-item label="检测结果类型" prop="resultType">
          <el-radio-group
            v-model="formData.resultType"
            size="small"
            @change="handleClick"
          >
            <el-radio :label="1" border>选择</el-radio>
            <el-radio :label="2" border>判定</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="检测结果默认值" prop="resultValue">
          <el-select
            clearable
            v-model="formData.resultValue"
            v-if="resultSelect"
          >
            <el-option
              v-for="item in resultList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            v-model="formData.resultValue"
            type="select"
            v-else
          ></el-input>
        </el-form-item>
        <el-form-item label="结果判定脚本" prop="scriptId">
          <el-select clearable v-model="formData.scriptId">
            <el-option
              v-for="item in scriptList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否在第一页显示" prop="shows">
          <el-radio-group v-model="formData.shows" size="small">
            <el-radio :label="0" border>是</el-radio>
            <el-radio :label="1" border>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="是否是保证项" prop="qualifiedType">
          <el-radio-group v-model="formData.qualifiedType" size="small">
            <el-radio :label="1" border>是</el-radio>
            <el-radio :label="0" border>否</el-radio>
          </el-radio-group>
        </el-form-item>
        <div
          class="button-group"
          style="display: flex; justify-content: center"
        >
          <el-button
            type="primary"
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="submitFn"
          >
            <span>创建</span>
          </el-button>
          <el-button
            style="width: 185px; margin: 0 20px"
            class="form-button"
            @click="clearFn"
          >
            <!-- <i v-if="item.icon" :class="item.icon"></i> -->
            <span>重置</span>
          </el-button>
        </div>
      </el-form>
      <!-- <tz-form
        width="130px"
        :formConfig="formConfig"
        :formBtns="formBtns"
        @submit="submitFn"
        @cleanFn="resultClean"
      ></tz-form> -->
      <!-- card content -->
    </el-card>
    <!-- card -->
  </div>
</template>

<script>
import { addInfo } from '@/api/checkinfo'
import { scriptList } from '@/api/scriptis'
import { queryEquipment } from '@/api/dictionary'

export default {
  data() {
    return {
      resultSelect: true,
      formData: {
        sort: '',
        itemType: '',
        itemName: '',
        qualifiedType: 1,
        resultType: 1,
        resultValue: '',
        status: 1, //1启用，2禁用
        shows: 0,
        scriptId: ''
      },
      itemList: [],
      resultList: [],
      scriptList: [],
      rules: {
        sort: [{ required: true, message: '序号必填', trigger: 'blur' }],
        itemType: [
          { required: true, message: '事项类型必填', trigger: 'blur' }
        ],
        itemName: [{ required: true, message: '事项名称必填', trigger: 'blur' }]
      }
    }
  },
  created() {
    this.queryEquipmentFn()
    this.getScriptList()
  },
  methods: {
    //获取类型
    queryEquipmentFn() {
      let types = ['check_resultValue', 'check_itemType']
      queryEquipment(types).then((res) => {
        console.log(res.data, '类型')
        this.itemList = res.data.check_itemType
        this.resultList = res.data.check_resultValue
      })
    },
    // 获取检测项判定脚本列表
    getScriptList() {
      let params = {
        pageSize: -1
      }
      scriptList(params).then((res) => {
        if (res.code == 200) {
          let scriptArr = res.data.records
          this.scriptList = scriptArr.map((item) => {
            return {
              value: item.id,
              label: item.scriptName
            }
          })
        }
      })
    },
    // 监听radio框变化
    handleClick(val) {
      this.formData.resultValue = ''
      console.log(val)
      if (val === 1) {
        this.resultSelect = true
      } else if (val === 2) {
        this.resultSelect = false
      }
    },
    // 重置
    clearFn() {
      this.resultSelect = true
      this.$refs['formData'].resetFields()
    },
    // 创建
    submitFn() {
      console.log(this.formData, '报告创建')
      this.$refs.formData.validate((isSuccess) => {
        if (isSuccess) {
          if (this.submited) return
          this.$loading({
            text: '报告添加中'
          })

          let addparams = {
            itemName: this.formData.itemName,
            itemType: this.formData.itemType,
            sort: this.formData.sort,
            shows: this.formData.shows,
            status: this.formData.status,
            scriptId: this.formData.scriptId,
            resultType: this.formData.resultType,
            resultValue: this.formData.resultValue,
            qualifiedType: this.formData.qualifiedType
          }
          console.log(addparams)
          addInfo(addparams).then((res) => {
            console.log(res.data, '创建')
            if (res.code == 200) {
              this.submited = true
              this.$message({
                message: '添加成功',
                type: 'success'
              })
              this.$router.go(-1)
            } else {
              this.$message({
                message: res.data,
                type: 'error'
              })
            }
          })
          this.$loading().close()
        }
      })
    }
  }
}
</script>

<style></style>
